export default "__VITE_ASSET__IioqH0HR__"